import React, { FunctionComponent } from 'react';
import { ScreenReaderContainer } from 'components';
import {
  MarketAgreedValue,
  MotorCoverType,
} from 'scenes/motor/flows/coverOptions/types';
import {
  toCurrencyWithSign,
  TWO_DECIMAL_PLACES,
} from 'scenes/common/helpers/currency';

const getBasedOnText = (
  marketOrAgreedValue: MarketAgreedValue,
  agreedVehicleValue: string
): string =>
  marketOrAgreedValue === MarketAgreedValue.Market
    ? 'market value'
    : `an agreed value of $${agreedVehicleValue}`;

export const ScreenReaderMarketOrAgreedUpdate: FunctionComponent<{
  coverType: MotorCoverType;
  marketOrAgreedValue: MarketAgreedValue;
  agreedVehicleValue: string;
  price: string;
}> = ({ coverType, marketOrAgreedValue, agreedVehicleValue, price }) => (
  <ScreenReaderContainer>{`Your ${coverType} insurance quote is ${toCurrencyWithSign(
    price,
    TWO_DECIMAL_PLACES
  )} including GST and Government charges, based on ${getBasedOnText(
    marketOrAgreedValue,
    agreedVehicleValue
  )}`}</ScreenReaderContainer>
);

export default ScreenReaderMarketOrAgreedUpdate;
